<script>
import '@/assets/scss/hub.scss';
export default {
  
};

//https://github.com/darkylmnx/Layout-system-with-vue-and-vue-router
</script>



<template>
  <div class="flex" id="signin">

    <div id="signin_cover">
      <!-- <img class="logo" src="../assets/img/logo-squared.svg" /> -->
      <img class="logo" src="../assets/img/logo-winerz-white.png" />
      <div><a href="/"><img class="logo-mobile" src="../assets/img/logo-winerz-white.png"></a></div>
    </div>

    <div id="signin_form">
      
      <!--  v-if="$route.name === 'register' || $route.name === 'login'" -->
      <div class="top-links">
        <router-link :class="{ current : $route.name === 'register' || $route.name === 'base-register' }" to="/register">{{$t(`Register`)}}</router-link>
        <router-link :class="{ current : $route.name === 'login' }" to="/login">{{$t(`Log In`)}}</router-link>
      </div>
      
      <div id="signin_form_inner">

        <div id="app_main">
            <slot />
        </div>

      </div>
    </div>

  </div>
</template>


<i18n>
  {
    "en": {
      "Register": "Register",
      "Log In": "Log In"
    },
    "fr": {
      "Register": "S'inscrire",
      "Log In": "Se connecter"
    }
  }
  </i18n>